/**
 * Shared accessibility style helpers.
 *
 * `visuallyHidden` matches the standard "sr-only" pattern: removes an element
 * from visual layout while keeping it readable to assistive technology. Use it
 * for status announcements (paired with `role="status"` + `aria-live`) or for
 * accessible names on icon-only / dot-only controls.
 */
import type { GriffelStyle } from '@coreai/fluentui-react';

export const visuallyHiddenStyle: GriffelStyle = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
};
